import styled, { css } from "styled-components";

type CounterButtonProps = {
  disabled: boolean;
};

export const Container = styled.div`
  /* flex-shrink: 0; */
  display: grid;
  grid-template-columns: 30% 40% 30%;
  width: 126px;
  height: 38px;
  align-items: center;
  border-radius: 26px;
  padding: 0 13px;
  border: 2px solid #e6e8ec;
`;
export const CounterButton = styled.button`
  position: relative;
  height: 24px;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0;
  
  & svg {
    fill: #9696b9;
    transition: fill 0.2s;
    /* +ph
            width: 27px
            height: 27px */
  }

  &:hover {
    & svg {
      fill: #161643;
    }
  }

  ${(props: CounterButtonProps) =>
    props.disabled &&
    css`
      	pointer-events: none
        opacity: 0.7
        svg
            fill: #B1B5C4;
    `}
`;

export const CounterValue = styled.div`
  /* flex-grow: 1; */
  text-align: center;
  font-family: Poppins-SemiBold;
  font-size: 21px;
  color: #161643;
  ${(props: CounterButtonProps) =>
    props.disabled &&
    css`
      opacity: 0.7;
    `}/* +ph
        font-size: 24px
        font-weight: 600 */
`;
